"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayProjectionToJSON = exports.GiveawayProjectionFromJSONTyped = exports.GiveawayProjectionFromJSON = exports.GiveawayProjection = void 0;
/**
 * Giveaway projection enum, used for including different field sets, of the Giveaway object. TODO: describe each field set
 * @export
 */
exports.GiveawayProjection = {
    Viewer: 'VIEWER',
    Creator: 'CREATOR',
    Admin: 'ADMIN'
};
function GiveawayProjectionFromJSON(json) {
    return GiveawayProjectionFromJSONTyped(json, false);
}
exports.GiveawayProjectionFromJSON = GiveawayProjectionFromJSON;
function GiveawayProjectionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GiveawayProjectionFromJSONTyped = GiveawayProjectionFromJSONTyped;
function GiveawayProjectionToJSON(value) {
    return value;
}
exports.GiveawayProjectionToJSON = GiveawayProjectionToJSON;
